
import { Component, inject } from '@angular/core';
import { ApiErrorService } from '../../core/services/api-error.service';

@Component({
  selector: 'app-api-error-banner',
  standalone: true,
  imports: [],
  template: `
    @if (errors.message(); as message) {
      <div class="api-error-banner" role="alert">
        <span>{{ message }}</span>
        <button type="button" aria-label="Dismiss error" (click)="errors.clear()">&times;</button>
      </div>
    }
    `,
  styles: [`
    .api-error-banner { align-items: center; background: #fbe9e7; border: 1px solid #d32f2f; color: #8b1d1d; display: flex; justify-content: space-between; gap: 12px; margin: 0 auto 16px; max-width: 1200px; width: calc(100% - 30px); padding: 10px 14px; }
    .api-error-banner button { background: transparent; border: 0; color: inherit; cursor: pointer; font-size: 24px; line-height: 1; }
  `],
})
export class ApiErrorBannerComponent {
  readonly errors = inject(ApiErrorService);
}
